require('../modules/es6.function.bind');
require('../modules/es6.function.name');
require('../modules/es6.function.has-instance');
module.exports = require('../modules/_core').Function;



//////////////////
// WEBPACK FOOTER
// /Users/joost/repositories/mobile-water/apotheken/polseweg/polseweg-frontend/~/core-js/es6/function.js
// module id = ../../../../core-js/es6/function.js
// module chunks = 0